import { FORCEFIELD_PALETTE } from "@consts/brand"
import { generatePalette } from "../../init/themeHandler"

// Puts the Forcefield colours on the page, unless the customer is white-label.
// Startup and useRebrandTheme both call this.
export const applyBrand = () => {
  // White-label customers keep the colours they set up in Chase, so every
  // Forcefield colour rule hangs off this class. The class goes on <body>, not
  // a wrapper element, because modals, popups and the photo gallery get
  // appended straight to <body> outside the React tree.
  document.body.classList.toggle("rebrand-colours", !window.theme)

  const palette = window.theme ?? FORCEFIELD_PALETTE
  generatePalette(palette.primary, palette.accent)
}
